export default {
  title: 'Aktivoi varaukset',
  buttons: {
    cancel: 'Peruuta',
    activate: 'Aktivoi varaukset',
  },
};
